const purchaseEn = {
    vendor: require('../../lang/en/purchase/Vendor').default,
};

export default purchaseEn;